const riq = [
  {
    path: '/riq',
    name: 'RIQ',
    component: () => import(/* webpackChunkName: "riqPage" */ '@/modules-v2/riq/index'),
    meta: { title: 'Rate Intelligence', requiresAuth: true },
  },
  {
    path: '/riq/:requestId',
    name: 'RIQDetail',
    component: () => import(/* webpackChunkName: "riqDetailPage" */ '@/modules-v2/riq/detail'),
    meta: { title: 'Rate Intelligence - Detail', requiresAuth: true },
  },
];

export default riq;
